import { LuChevronRight } from 'react-icons/lu';
import { PiCheckCircleFill } from 'react-icons/pi';
import { FormattedMessage, useIntl } from 'react-intl';
import { Locales } from '@_/static';
import { withDialog, DialogHeader, DialogTitle, Link, List, ListItem, Text } from '@_/ui';

export const SelectLocaleDialog = withDialog(
  {
    showCloseButton: true
  },
  function SelectLocaleDialogContent() {
    const { locale: currentLocale } = useIntl();

    return (
      <>
        <DialogHeader>
          <DialogTitle>
            <FormattedMessage id="heading.choose-language" defaultMessage="Choose your language" />
          </DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-y-3">
          <List variant="distinct">
            {Locales.map(({ code, name }) => {
              const isCurrentLocale = currentLocale === code;
              return (
                <ListItem
                  key={code}
                  renderLink={
                    !isCurrentLocale
                      ? props => (
                          <Link
                            {...props}
                            disabled={currentLocale === code}
                            hash={prev => prev ?? ''}
                            params={{ locale: code }}
                            reloadDocument={true}
                            search={prev => prev}
                            to="."
                          />
                        )
                      : undefined
                  }
                >
                  <div className="flex items-center justify-between">
                    <Text semibold>{name}</Text>

                    {isCurrentLocale ? (
                      <PiCheckCircleFill className="size-4.5 text-black/75" />
                    ) : (
                      <LuChevronRight className="size-4" />
                    )}
                  </div>
                </ListItem>
              );
            })}
          </List>
        </div>
      </>
    );
  }
);
